import { render, staticRenderFns } from "./OriginalTable.vue?vue&type=template&id=85ba486e"
import script from "./OriginalTable.vue?vue&type=script&lang=js"
export * from "./OriginalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports